import { cn } from "@/lib/utils";

export const GamifiedButton = ({ children, className, variant = "primary", disabled, ...props }) => {
  const variants = {
    primary: "bg-primary text-white shadow-[0_5px_0_#5a8ce0] active:shadow-[0_0px_0_#5a8ce0] active:translate-y-[5px] hover:brightness-105",
    secondary: "bg-secondary text-white shadow-[0_5px_0_#36a4be] active:shadow-[0_0px_0_#36a4be] active:translate-y-[5px] hover:brightness-105",
    accent: "bg-accent text-slate-900 shadow-[0_5px_0_#d4ac0d] active:shadow-[0_0px_0_#d4ac0d] active:translate-y-[5px] hover:brightness-105",
    ghost: "bg-white text-slate-700 border-2 border-slate-200 shadow-[0_4px_0_#e2e8f0] active:shadow-[0_0px_0_#e2e8f0] active:translate-y-[4px] hover:bg-slate-50",
  };
  return (
    <button
      disabled={disabled}
      className={cn(
        "btn-push relative inline-flex items-center justify-center gap-2 px-6 py-3.5 font-extrabold rounded-2xl select-none",
        "disabled:opacity-50 disabled:pointer-events-none text-base",
        variants[variant],
        className,
      )}
      {...props}
    >
      {children}
    </button>
  );
};
